import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'reducers/stateTypes';

export const selectIsDebugInfoOn = createSelector(
  (state: GlobalState) => state.debugInfo,
  (debugInfo) => debugInfo?.isDebugModeOn ?? false,
);
